<div class="single-select-container pr-[4px]">
  <select [(ngModel)]="selectedId" class="ag-cell-edit-input pl-[7px]">
    @for (opt of opts; track opt) {
      <option [ngValue]="opt.ID">{{ opt.Name }}</option>
    }
  </select>
</div>
